// Hand-curated presentation order for the public gallery.
//
// Every frame in the archive was reviewed by eye (Oct 2026) and scored 1–10 on
// composition, light, colour and impact. The gallery opens on FEATURED in the
// exact order listed (a paced mix of portrait, landscape and architecture),
// then continues best-first by SCORES. Frames uploaded after this pass have no
// score and fall back to DEFAULT_SCORE, so new work still surfaces early.
// To promote or bury a frame, edit its score; to change the opening, reorder
// FEATURED. Ids are Firestore doc ids (a few legacy docs use numeric ids).

export const DEFAULT_SCORE = 7.5;

// The welcome sequence — the first section a visitor scrolls through.
export const FEATURED = [
  107, // Bedouin Man — Little Petra
  191, // Alcazar Gardens Underground — Sevilla
  "BJd7BpwXWBK7LCbTuYOY", // DSC8722 — Atacama
  26, // Karen Woman — Chiang Mai
  243, // Kyoto Shrine To Green — Kyoto
  97, // Dahabiya Aswan — Aswan
  183, // Alhambra Windows — Grenada
  246, // Umbrellas — Kurama
  112, // Bedouin at Petra — Petra
  40, // Notre Dame — Paris
  "GZGziSgBhXhYhHmP4iDi", // DSC8583 — Atacama
  267, // Korean Guard First — Seoul
  115, // Petra Camels — Petra
  "gF8Pk7I2QrTiaISArBOb", // DSC3803 — Bora Bora
  177, // Smoking Man — Hanoi
  5, // Philae Water — Philae
  "kQFVfcBPCr7iBhgnnSaN", // DSC8792 — Atacama
  247, // Turtle Cafe — Kyoto
  49, // Hassan II Mosque — Casablanca
  173, // Hoi An Bicycle — Hoi An
  "ZMoEx2Whghr4PLYUDfDY", // DSC8112 — Rapa Nui
  41, // Louvre Museum — Paris
  "5aRH35ZuPfLuJPZNaVrD", // DSC7809 — Sacred Valley
  76, // Risani Mosque — Risani
];

// Daily-rotating hero frames: showstoppers that also survive a full-bleed crop.
export const HERO = [
  97, // Dahabiya Aswan — Aswan
  "BJd7BpwXWBK7LCbTuYOY", // DSC8722 — Atacama
  191, // Alcazar Gardens Underground — Sevilla
  243, // Kyoto Shrine To Green — Kyoto
  "GZGziSgBhXhYhHmP4iDi", // DSC8583 — Atacama
  49, // Hassan II Mosque — Casablanca
  "gF8Pk7I2QrTiaISArBOb", // DSC3803 — Bora Bora
  40, // Notre Dame — Paris
  183, // Alhambra Windows — Grenada
  "kQFVfcBPCr7iBhgnnSaN", // DSC8792 — Atacama
  "8qFHORALo6vdorW7of0G", // DSC8798 — Atacama
  76, // Risani Mosque — Risani
];

export const SCORES = {
  0: 6,
  "02EQykNn1ivkMxHLhyHm": 7,
  "05EEeZCCQ81oquAfKgbH": 7,
  "07r84MUSRjRTKScMwhZl": 5,
  "0ohOMQ6c19tSW01pLPDo": 7,
  "0xwFkkrCPonk7Sg6Bmsu": 8,
  1: 7,
  10: 5,
  100: 7,
  101: 7,
  102: 6,
  103: 7,
  104: 7,
  105: 7,
  106: 7,
  107: 9,
  108: 8,
  109: 8,
  11: 5,
  110: 8,
  111: 7,
  112: 8,
  113: 7,
  114: 7,
  115: 8,
  116: 7,
  117: 7,
  118: 8,
  119: 6,
  12: 5,
  120: 6,
  121: 6,
  122: 6,
  123: 5,
  124: 8,
  125: 5,
  126: 6,
  127: 7,
  128: 5,
  129: 7,
  13: 5,
  130: 6,
  131: 6,
  132: 6,
  133: 5,
  134: 6,
  135: 7,
  136: 8,
  137: 7,
  138: 7,
  139: 7,
  14: 5,
  140: 7,
  141: 8,
  142: 8,
  143: 6,
  144: 7,
  145: 5,
  146: 6,
  147: 4,
  148: 7,
  149: 6,
  15: 7,
  150: 4,
  151: 6,
  152: 6,
  153: 7,
  154: 7,
  155: 8,
  156: 7,
  157: 8,
  158: 6,
  159: 8,
  16: 4,
  160: 6,
  161: 7,
  162: 5,
  163: 5,
  164: 5,
  165: 7,
  166: 6,
  167: 7,
  168: 7,
  169: 5,
  17: 6,
  170: 7,
  171: 8,
  172: 6,
  173: 8,
  174: 6,
  175: 6,
  176: 7,
  177: 8,
  178: 7,
  179: 6,
  18: 5,
  180: 7,
  181: 6,
  182: 6,
  183: 8,
  184: 8,
  185: 6,
  186: 7,
  187: 7,
  188: 7,
  189: 7,
  19: 5,
  190: 6,
  191: 9,
  192: 5,
  193: 6,
  194: 6,
  195: 7,
  196: 6,
  197: 4,
  198: 6,
  199: 5,
  2: 5,
  20: 7,
  200: 5,
  201: 6,
  202: 6,
  203: 7,
  204: 7,
  205: 7,
  206: 6,
  207: 7,
  208: 7,
  209: 7,
  21: 6,
  210: 7,
  211: 5,
  212: 6,
  213: 6,
  214: 6,
  215: 6,
  216: 7,
  217: 6,
  218: 5,
  219: 6,
  22: 7,
  220: 7,
  221: 7,
  222: 6,
  223: 8,
  224: 6,
  225: 6,
  226: 7,
  227: 6,
  228: 7,
  229: 6,
  23: 7,
  230: 7,
  231: 7,
  232: 7,
  233: 6,
  234: 6,
  235: 8,
  236: 6,
  237: 8,
  238: 7,
  239: 7,
  24: 6,
  240: 7,
  241: 8,
  242: 8,
  243: 8,
  244: 6,
  245: 7,
  246: 9,
  247: 8,
  248: 7,
  249: 7,
  25: 8,
  250: 8,
  251: 7,
  252: 7,
  253: 6,
  254: 6,
  255: 7,
  256: 5,
  257: 7,
  258: 6,
  259: 8,
  26: 9,
  260: 7,
  261: 7,
  262: 8,
  263: 7,
  264: 7,
  265: 7,
  266: 6,
  267: 8,
  268: 8,
  269: 7,
  27: 7,
  270: 7,
  28: 7,
  3: 7,
  30: 7,
  31: 8,
  32: 6,
  33: 7,
  34: 5,
  35: 6,
  36: 6,
  37: 6,
  38: 7,
  "3I9vtO4iqGUsPvQ30fuK": 6,
  4: 6,
  40: 8,
  41: 8,
  43: 7,
  44: 6,
  45: 6,
  46: 6,
  47: 7,
  48: 6,
  49: 8,
  "4DgyMbRVbxVgho1uSG78": 7,
  "4ZtZEeyBIZ7dzgo11y05": 7,
  5: 8,
  50: 6,
  51: 6,
  53: 7,
  54: 7,
  56: 7,
  57: 3,
  58: 5,
  59: 7,
  "5aRH35ZuPfLuJPZNaVrD": 8,
  "5tKbdFmTPL3YtHzHY2r0": 5,
  "5uWwuupatNK3RgMU18CB": 7,
  6: 7,
  60: 5,
  62: 6,
  63: 6,
  66: 5,
  68: 6,
  69: 6,
  7: 6,
  70: 7,
  71: 7,
  73: 6,
  74: 6,
  75: 7,
  76: 8,
  77: 6,
  78: 5,
  79: 7,
  8: 7,
  80: 7,
  81: 7,
  82: 8,
  83: 7,
  84: 7,
  85: 6,
  86: 7,
  87: 6,
  88: 7,
  89: 5,
  "8Cw1stlpwJxD8pY8ACOr": 6,
  "8jH2qqTRNYRqoYWUUr5w": 6,
  "8qFHORALo6vdorW7of0G": 8,
  9: 6,
  90: 6,
  91: 7,
  92: 7,
  93: 7,
  94: 7,
  95: 6,
  96: 7,
  97: 9,
  98: 5,
  99: 7,
  "9cELRlSe5AR7yeoZ90px": 6,
  "9nNL7QoBRYJFjkrhScac": 7,
  "BAgfW5lPRYvICX6HH6Ps": 7,
  "BJd7BpwXWBK7LCbTuYOY": 9,
  "Cac0hELa5bVbAPjlVhul": 7,
  "DAbgpyDbhvTWpGKlhrRW": 8,
  "DBDqOUPLTIlmmB9ATGkQ": 7,
  "DGgL8wGUKKU6wJxJ3gaR": 7,
  "DXf64UkvfvI1h56ZV64S": 7,
  "Du6ifhoAy3vWITjjroE7": 7,
  "E4WiEIKbBQ48LOKqMhWc": 6,
  "EnIJ1uOWEb1OQAgKffvx": 6,
  "GZGziSgBhXhYhHmP4iDi": 8,
  "Gx1nL4YC00c9NlzEbc2q": 6,
  "HYkIz1P9UjwAFuB2Cr56": 7,
  "Hef3GbFPACKL7W4tldzy": 7,
  "JIiPwifyoAAzbg63fWaV": 7,
  "JovQnfLGiABStGzs2u61": 6,
  "K0w76hNbicVELJxA4q4W": 7,
  "LXSGoSQRRNsOGzpecwmt": 3,
  "Lc9t0yGbNpznXwMJg5SV": 6,
  "MCd7r7KEpbSZD7ykidOV": 5,
  "MXg2loPtbNL7kuG40MHk": 7,
  "MrprVkPw9rUrz3cfMP8w": 6,
  "NdHF2ljZIMU8Hn3v91br": 7,
  "OAuYLEJRN1Bkdio0Zy4u": 6,
  "PS7DRWSoGnqZNURsynXj": 8,
  "QSCVkifV8u6yFRk6ahty": 6,
  "SmvR8fxowrLn0tE9djAr": 7,
  "TUIJ7ifBhbWUz3JWR7Xz": 7,
  "TwzAdDSRoICVRUBbW0R8": 6,
  "UCYMGMyNSnSsmDvKMEpQ": 7,
  "V0Z8nBSakR2X4kwuWoyS": 6,
  "V4lvtV7fMAeq3juCA2od": 7,
  "Vsnb1poLNMZNsvInKaV9": 7,
  "WBg7BMzbzQDd7MpU4guK": 7,
  "WqdX6EjTGBb6CSBlr1i9": 6,
  "XjVWbwMfHsRISi9Threc": 7,
  "Y02MY7vb0XZRjndJY2fV": 6,
  "Y2qz4P9rZizZ6fQBI4F6": 6,
  "ZHdzLLNDGvtorOy7PM8B": 7,
  "ZMoEx2Whghr4PLYUDfDY": 8,
  "ZNnhC79jIEw58SQkhcHk": 7,
  "ZiyPQksgbTEQir2vhPBc": 7,
  "ZojvTWs6o3j18U2VpMXC": 7,
  "anznO2mpA9sZRu054BAR": 7,
  "bEiu0lu4MylZSs9Z3wNC": 7,
  "cDjdad9mUASDXr4cu56w": 8,
  "cVJ9xtppGLGTGaBqFpUE": 8,
  "clJrYMRYTGGb1fcKrIcv": 6,
  "crirf4gjPJxjGYLGKDzZ": 7,
  "djG6xwTF7spzLMUste0a": 8,
  "e7GWPyCuiavxJJ7KICO7": 5,
  "f3HCB5icM82wog0CAaYE": 8,
  "fU8RvdYDbemxkiZ5Jlh9": 8,
  "fWUJ3bu0DufmtqMtvjUq": 8,
  "fhemG52EXNWmIhUuQg3P": 7,
  "fv2d1j28SoULHwodysMz": 7,
  "gF8Pk7I2QrTiaISArBOb": 8,
  "hNNKXVbg2n5gzVRMm0b8": 7,
  "i7wZ7rNgUFeF1BCGQy1b": 7,
  "iSESpvpQkyc7QW9ey1Zq": 8,
  "icvo2NdhxNlQmKBsG7iQ": 3,
  "jd15qm1aWOdrKNywo1Bt": 6,
  "jiHVEbHZUlBCqSIojC9h": 7,
  "kQFVfcBPCr7iBhgnnSaN": 8,
  "l4LU9SqZOuZkam0q1YdJ": 8,
  "mMWFNyFoogBLekeajqDx": 7,
  "mPq5SV8oerdkXL4DCjc1": 7,
  "n43qgvtw7AW8i7gV38Bu": 8,
  "naS8EpBGse3jIlcPiWxR": 7,
  "ncGB4zIzODTKtbB1HZyl": 6,
  "ns2o94DBh1bWC1sW8hHL": 5,
  "o1mMBTHOXqqZP6RUyoiW": 6,
  "qqSM325b4ygbhfbS0peS": 7,
  "rD06nBCgyb4Z5XF2CW8P": 7,
  "rlMDaybpm4A1wxvVQ4gE": 7,
  "uRZtfJQr66O7sk5ku04B": 7,
  "vp6NPFlvdrafxSLJVG1B": 7,
  "w1Btj6FUR5wYRtx1UOJH": 7,
  "w9EA0KO9ihUrP2gi6wm8": 8,
  "wAm2o6oVMyLk6IusJ0pi": 7,
  "wnq5QIKAaZapihcGS00j": 3,
  "xtDu2fBhnJHuyIZx8IXz": 8,
  "zSA4B8kvgXwV89nwre3G": 7,
};
